import styled from 'styled-components';
import OtherServiceCard from './OtherServiceCard';

type PageType = 'ai' | 'quant' | 'map' | 'algorithm';

interface Props {
  page: 'ai' | 'quant' | 'map' | 'algorithm';
}

interface ServiceItem {
  title: string;
  desc: string;
  link: string;
  img: string;
  color: string;
}

const service = {
  ai: {
    title: 'AI 경공매 찾기',
    desc: 'AI와 대화하며 경매 물건 찾아보세요',
    link: '/chat',
    img: 'card_aichat_mobile',
    color: '#C7C4FF',
  },
  quant: {
    title: '퀀트 분석 테마 추천',
    desc: '나에게 맞는 테마를 선택해\n체계적인 투자전략과 수익성도 확인해보세요',
    link: '/quant',
    img: 'card_quant_mobile',
    color: '#FBB2CA',
  },
  algorithm: {
    title: '알고리즘 추천물건',
    desc: '나만의 전략을 만들어 물건도 찾고\n수익성도 확인해보세요',
    link: '/AiRecommendation',
    img: 'card_algorithm_mobile',
    color: '#A3D4FF',
  },
  map: {
    title: '지도검색',
    desc: '찾고싶은 물건은 있는데\n주소도, 사건번호도 모르겠다면',
    link: '/map',
    img: 'card_map_mobile',
    color: '#A3EDC1',
  },
};

function OtherService({ page }: Props) {
  const serviceList = Object.entries(service).filter(
    ([key, val]) => key !== page && !!val.title && !!val.link,
  );
  return (
    <Section>
      <TitleBox>
        <TitleLabel>땅집고옥션</TitleLabel>
        <Title>이런 서비스는 어떠세요?</Title>
      </TitleBox>
      <Content>
        {serviceList.map(([key, item]) => (
          <OtherServiceCard
            key={key}
            title={item.title}
            desc={item.desc}
            link={item.link}
            img={item.img}
            color={item.color}
          />
        ))}
      </Content>
    </Section>
  );
}

export default OtherService;

const Section = styled.div`
  background: #f0f4fa;
  display: flex;
  padding: 24px 16px 72px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const TitleLabel = styled.div`
  color: #008aff;
  font-size: 14px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const Title = styled.div`
  color: #222;
  font-size: 20px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.4px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;
`;
